/** Typed `localStorage` wrapper — every value is JSON-serialized on write and parsed on read. */
export class LocalStorageApp {
  /** Clears all of local storage (not just this app's keys). */
  public static clear(): void {
    localStorage.clear();
  }

  /** Reads and JSON-parses a stored value. @returns `null` if the key is absent. */
  public static getItem<T>(key: string): T | null {
    return localStorage.getItem(key)
      ? JSON.parse(localStorage.getItem(key) || "")
      : null;
  }

  /** JSON-serializes and stores a value. */
  public static setItem<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public static removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
